import { BankAccount } from "./bank-account";
import { Destination } from "./destination";
import { Author } from "./author";
import { AccessPointSettings } from "./access-point-settings";
import {
  asBoolean,
  asDate,
  asNumber,
  asString,
  isObject,
  parseList,
} from "./model-utils";
import { enumValue, FundLocation, ProfileType } from "./enums";

export class AccessPoint {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.qrCode = asBoolean(json.qrCode);
    this.archive = asBoolean(json.archive);
    this.accessPointId = asString(json.accessPointId);
    this.name = asString(json.name);
    this.controlType = asString(json.controlType);
    this.profileId = asString(json.profileId);
    this.profileType = enumValue(ProfileType, json.profileType);
    this.qrCodeUrl = asString(json.qrCodeUrl);
    this.address = asString(json.address);
    this.country = asString(json.country);
    this.countryCode = asString(json.countryCode);
    this.status = asString(json.status);
    this.category = Array.isArray(json.category)
      ? json.category.map(String)
      : asString(json.category)
        ? [asString(json.category)]
        : undefined;
    this.position = asNumber(json.position);
    this.currency = asString(json.currency);
    this.createdAt = asDate(json.createdAt);
    this.updatedAt = asDate(json.updatedAt);
    this.fundLocation = enumValue(FundLocation, json.fundLocation);
    this.settings = AccessPointSettings.fromJson(json.settings);
    this.author = Author.fromJson(json.author);
    this.invoiceBankAccount = parseList(
      json.invoiceBankAccount,
      BankAccount.fromJson,
    );
    this.bankAccount = parseList(json.bankAccount, BankAccount.fromJson);
    this.deliveryOptions = parseList(json.deliveryOptions, Destination.fromJson);
    this.discountOptions = Array.isArray(json.discountOptions)
      ? json.discountOptions
      : [];
    this.people = Array.isArray(json.people) ? json.people : undefined;
    this.documentTemplates = Array.isArray(json.documentTemplates)
      ? json.documentTemplates
      : undefined;
  }

  static fromJson(json: any) {
    return isObject(json) ? new AccessPoint(json) : json;
  }
}
